/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the orders error selector
 * @returns {OrderEntity | null} The `order` that has been selected from the store
 */
const ordersErrorSelector = createSelector(ordersSelector, (orders) => orders.error);

export default ordersErrorSelector;
